<template>
  <div v-hotkey="keymap" class="search-result-nav">
    <div
      class="result-nav-prev"
      :disabled="isBackDisabled"
      @click="navigateBack"
    >
      <span class="icon-container">
        <BaseIcon icon-name="ico-arrow-chevron" />
      </span>

      <span>{{ navigationIndex + 1 }}</span>
    </div>

    <div class="result-nav-curr">
      <span class="page-divider"
        ><BaseIcon icon-name="ico-book-new-half"
      /></span>
    </div>

    <div
      class="result-nav-next"
      :disabled="isForwardDisabled"
      @click="navigateForward"
    >
      <span>{{ totalDocsCount }}</span>

      <span class="icon-container">
        <BaseIcon icon-name="ico-arrow-chevron" />
      </span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import BaseIcon from '@/components/BaseIcon';

  import { NAVIGATION_STEP } from '@/constants/constants';

  import EventEnum from '@/enums/EventEnum';
  import eventManager from '@/services/EventService';

  import * as log from 'loglevel';
  log.setLevel('info');

  export default {
    name: 'Navigation',
    components: {
      BaseIcon,
    },
    computed: {
      ...mapState('NavigationStore', [
        'navigationList',
        'navigationIndex',
        'totalDocsCount',
      ]),
      ...mapState('HitsStore', ['activeHit']),

      keymap() {
        return {
          'ctrl+left': () => {
            this.navigateBack();
          },
          'ctrl+right': () => {
            this.navigateForward();
          },
        };
      },

      isBackDisabled() {
        return this.navigationIndex + NAVIGATION_STEP <= 1;
      },

      isForwardDisabled() {
        return this.navigationIndex === this.totalDocsCount - NAVIGATION_STEP;
      },
    },
    mounted() {
      eventManager.subscribe(EventEnum.NAVIGATE_FORWARD, this.navigateForward);
      eventManager.subscribe(EventEnum.NAVIGATE_BACK, this.navigateBack);
    },
    destroyed() {
      eventManager.unsubscribe(
        EventEnum.NAVIGATE_FORWARD,
        this.navigateForward
      );
      eventManager.unsubscribe(EventEnum.NAVIGATE_BACK, this.navigateBack);
    },
    methods: {
      navigateForward() {
        if (this.isForwardDisabled) {
          return;
        }
        this.$_navigate({
          increment: true,
        });
      },

      navigateBack() {
        if (this.isBackDisabled) {
          return;
        }
        this.$_navigate({
          increment: false,
        });
      },

      getLocalizedNumber(number) {
        return this.$store.getters['ContextStore/getLocalizedNumber'](number);
      },

      $_navigate(options) {
        const activeHitIndex = options.increment
          ? this.navigationIndex + NAVIGATION_STEP
          : this.navigationIndex - NAVIGATION_STEP;
        this.$store.dispatch(
          'NavigationStore/setHitByNavigationIndex',
          activeHitIndex
        );
      },
    },
  };
</script>

<style scoped lang="less">
  @import 'Navigation.less';
</style>
